import { page } from "./page";

export class contentModel{

     
    content:page;
    content_type:string;
    result:string;
    language:string;
    cat_id:string;
    page_id:string;

}

